import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AccessPage from "@/pages/AccessPage";
import PricingPage from "@/pages/PricingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminRequests from "@/pages/AdminRequests";
import AdminRequestDetail from "@/pages/AdminRequestDetail";
import AdminCodes from "@/pages/AdminCodes";
import AdminPricing from "@/pages/AdminPricing";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/access" replace />} />
          <Route path="/access" element={<AccessPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/requests"
            element={
              <ProtectedRoute>
                <AdminRequests />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/requests/:id"
            element={
              <ProtectedRoute>
                <AdminRequestDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/codes"
            element={
              <ProtectedRoute>
                <AdminCodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/pricing"
            element={
              <ProtectedRoute>
                <AdminPricing />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
